import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { updateUserData } from "../reducers/reducerUser"; // או איך שקראת לקובץ
import http from "../../services/http/http";
import toast from "react-hot-toast";

const apiUrl = `https://mu-beginning.co.il/paypal`;

// ✅ שלב 1: קריאה מאובטחת לשרת (שליחת orderId בלבד!)
export const verifyPayPalOrder = createAsyncThunk(
  "verifyPayPalOrder",
  async ({ orderId, username }, { dispatch }) => {
    const response = await http.post(`${apiUrl}/verify`, {
      orderId,
      username,
    });

    // ✅ עדכון ל־Redux
    dispatch(updateUserData(response.data));

    // toast.success("✅ Credits added successfully!");

    return response.data;
  }
);

const initialState = {
  userLogin: {
    data: null,
    status: "",
  },
  buyCredits: {
    data: [],
    status: "",
  },
};

// ✅ Slice
const PayPalApi = createSlice({
  name: "MuOnlinePayPalValidation",
  initialState,
  extraReducers: {
    [verifyPayPalOrder.fulfilled]: (state, { payload, meta }) => {
      state.buyCredits.data = payload;
      state.buyCredits.status = meta.requestStatus;

      state.userLogin.data = {
        username: payload.username,
        data: payload.user,
      };
    },

    [verifyPayPalOrder.rejected]: (state, { payload, meta }) => {
      state.buyCredits.data = payload;
      state.buyCredits.status = meta.requestStatus;
      toast.error("❌ Failed to verify PayPal payment");
    },
  },
});

export default PayPalApi.reducer;
